/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Newsletter(props) {
    return (
        <SvgIcon {...props}>
            <polygon points="10.369,0.059 10.339,0.059 10.339,0.085" />
            <path d="M0,2v10h13V2.007L0,2z M10.657,3.294l-4.15,3.73L2.328,3.289L10.657,3.294z M1.238,4.026l3.308,2.957 L1.26,9.937L1.238,4.026z M2.321,10.707l3.185-2.864l1.006,0.899l1-0.899l3.208,2.869L2.321,10.707z M8.466,6.985l3.238-2.91 l0.022,5.824L8.466,6.985z" />
        </SvgIcon>
    );
}

Newsletter.defaultProps = {
    viewBox: '0 0 13 16'
};

export default Newsletter;
